'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _he_IL = require('../../date-picker/locale/he_IL');

var _he_IL2 = _interopRequireDefault(_he_IL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _he_IL2['default'];